import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import {
  CLINIC_SPECIALTIES,
  CLINIC_TYPES,
} from '@backend/db/const/db.const.ENUMS';

import { ReportResultsPage } from '@frontend/features/analytics/components/ReportResultsPage';

const reportSearchSchema = z.object({
  groupFilterMode: z.enum(['all', 'include', 'exclude']).optional(),
  groupFilterGroups: z.array(z.string()).optional(),
  groupNames: z.array(z.string()).optional(),
  clinicTypes: z.array(z.enum(CLINIC_TYPES)).optional(),
  specialties: z.array(z.enum(CLINIC_SPECIALTIES)).optional(),
  statuses: z
    .array(
      z.enum([
        'lead',
        'active',
        'onHold',
        'inactive',
        'billing',
        'recruitment',
      ]),
    )
    .optional(),
  networkStatuses: z.array(z.enum(['in', 'out', 'unspecified'])).optional(),
  features: z.array(z.string()).optional(),
});

export const Route = createFileRoute('/analytics/report/$reportId')({
  component: ReportResultsPage,
  validateSearch: reportSearchSchema,
});
